module.exports = __webpack_public_path__ + "img/overfold-logo-wire.7c0d615d.png";